<template>
  <div class="ad-manage">
    <!-- 选择广告主账号 -->
    <el-card class="filter-card">
      <label>广告主账号：</label>
      <el-select
        v-model="advertiser_ids.value"
        size="mini"
        placeholder="请选择广告主账号"
        multiple
        collapse-tags
        filterable
        @change="advertiserIdsChange"
      >
        <el-option
          v-for="(item, index) in advertiser_ids.options"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <span style="margin-left: 10px">
        <label>项目：</label>
        <el-select
          v-model="project_ids.value"
          size="mini"
          placeholder="请选择项目"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, index) in project_ids.options"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </span>
      <el-button
        :loading="pull_loading"
        style="margin-left: 10px"
        size="mini"
        type="primary"
        @click="pullPromotionList"
      >同步广告</el-button>

      <el-button
        class="fr"
        size="mini"
        type="primary"
        @click="ad_config.is_show = true"
      >创建广告</el-button>
      <el-button
        class="fr"
        size="mini"
        type="success"
        @click="toIntelligenceCreate"
      >智能创建</el-button>
    </el-card>

    <!-- 筛选查询 -->
    <el-card class="filter-card">
      <app-filter
        ref="filter-dom"
        :filter-list="table_filter"
        default-label-width="120px"
        @search="searchTable"
      />
    </el-card>

    <!-- 广告列表 -->
    <el-card class="box-card">
      <div class="func-box" style="padding: 20px 0">
        <label>批量操作：</label>
        <el-select
          v-model="batch_operate_config.value"
          size="mini"
          placeholder="选择需要批量的操作"
        >
          <el-option
            v-for="(item, index) in batch_operate_config.options"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="warning"
          size="mini"
          plain
          @click="batchExecute"
        >执行</el-button>
      </div>

      <app-table
        ref="ad_table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getPromotionList"
        :check="true"
        @select-tr="tableCheckTr"
      />
    </el-card>

    <el-drawer
      :title="ad_config.title"
      :visible.sync="ad_config.is_show"
      size="900px"
      @close="adFormCancel"
    >
      <ad-create
        v-if="ad_config.is_show"
        :ad-data="ad_config.data"
        @cancel="adFormCancel"
        @confirm="adFormConfirm"
      />
    </el-drawer>
  </div>
</template>

<script>
import { getPromotionListApi, batchDeletePromotionApi, pullPromotionListApi } from '@/api/promotion/jrtt';
import { getProjectSelectorApi } from '@/api/project/jrtt';
import { getMediasListApi } from '@/api/medias';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'ad-create': () => import('./components/ad-create'),
  },
  data() {
    return {
      table_filter: require('./model/table-filter')(this),
      table_key: require('./model/table-key')(this),
      /** 同步加载 */
      pull_loading: false,
      /** 表格请求参数 */
      table_params: {
        page: 1,
        limit: 10,
      },
      /** 表格勾选列表 */
      table_check_list: [],
      /** 广告主账号筛选框 */
      advertiser_ids: {
        options: [],
        value: [],
      },

      // 广告筛选框
      project_ids: {
        options: [],
        value: [],
      },

      /** 批量操作配置 */
      batch_operate_config: {
        options: [
          {
            label: '删除',
            value: 'delete',
          },
        ],
        value: '',
      },

      /** 表格数据 */
      table_list_data: {
        list: [{
          id: 1,
        }],
      },

      /**
       * 广告配置
       */
      ad_config: {
        is_show: false,
        title: '创建广告',
        data: {},
      },
    };
  },
  created(){
    this.getMediasList();

    const { advertiser_id, project_id } = this.$route.query;
    if (advertiser_id) {
      this.advertiser_ids.value = [Number(advertiser_id)];
      this.table_params.advertiser_ids = this.advertiser_ids.value;
    }

    if (project_id) {
      this.project_ids.value = [project_id];
      this.table_params.project_ids = this.project_ids.value;
    }

    this.getProjectSelector();
  },
  methods: {
    // 广告主账号变化事件
    advertiserIdsChange() {
      this.getProjectSelector();
    },
    // 查询表格
    searchTable(params_value) {
      const { create_time, update_time } = params_value;
      if (create_time?.length) {
        params_value['start_created_time'] = create_time[0];
        params_value['end_created_time'] = create_time[1];
        delete params_value.create_time;
      } else {
        params_value['start_created_time'] = null;
        params_value['end_created_time'] = null;
      }

      if (update_time?.length) {
        params_value.start_updated_time = update_time[0];
        params_value.end_updated_time = update_time[1];
        delete params_value.update_time;
      } else {
        params_value['start_updated_time'] = null;
        params_value['end_updated_time'] = null;
      }

      this.table_params = {
        ...this.table_params,
        ...params_value,
        advertiser_ids: this.advertiser_ids.value,
        project_ids: this.project_ids.value,
      };

      this.$nextTick(() => {
        this.$refs.ad_table.seekTable();
      });
    },

    /**
     * 表格勾选行事件
     */
    tableCheckTr(list) {
      this.table_check_list = list;
    },

    /**
     * 批量执行
     */
    batchExecute() {
      const { value } = this.batch_operate_config;
      // 判断是否选中批量操作
      if (!value) {
        this.$message.warning('请选择需要批量执行的操作');
        return;
      }

      // 判断是否选中操作的数据
      if (!this.table_check_list.length) {
        this.$message.warning('请选中需要操作的数据');
        return;
      }

      switch (value) {
        case 'delete':
          this.$confirm('确认要删除吗？').then(_ => {
            batchDeletePromotionApi({
              source_ids: this.table_check_list.map(item => {
                return item.id;
              }),
            }).then(res => {
              this.$message.success(res.message);
              this.$refs.ad_table.seekTable();
            });
          }).catch(() => {});

          break;

        default:
          break;
      }
    },

    /**
     * 修改广告
     * @param { Object } row 行数据
     */
    editAd(row) {
      this.ad_config.is_show = true;
      this.ad_config.data = row;
      this.ad_config.title = '编辑广告';
    },

    /**
     * 广告表单取消
     */
    adFormCancel() {
      if (this.ad_config.data) {
        this.ad_config.data = null;
        this.ad_config.title = '创建广告';
      }

      this.ad_config.is_show = false;
    },

    /**
     * 广告表单确定
     */
    adFormConfirm() {
      this.adFormCancel();

      this.$refs.ad_table.seekTable();
    },

    getPromotionList: getPromotionListApi,

    /** 同步项目列表 */
    async pullPromotionList() {
      this.pull_loading = true;
      try {
        const pull_messages = [];
        for (let i = 0; i < this.advertiser_ids.value.length; i++) {
          const id = this.advertiser_ids.value[i];
          const item = await pullPromotionListApi({ advertiser_id: id });
          pull_messages.push(id + '=>' + item.message + '</br>');
        }

        // 显示同步结果
        if (pull_messages.length) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'success',
            message: `
              <h2>同步结果： </h2></br>
              ${pull_messages.join('')}
            `,
          });
        } else {
          this.$message.warning('请选择广告主账号！');
        }

        this.pull_loading = false;
      } catch (error) {
        this.pull_loading = false;
      }
    },

    /** 获取广告账号列表 */
    getMediasList() {
      return getMediasListApi({
        type: 'jrtt',
        is_list: true,
      }).then((res) => {
        this.advertiser_ids.options = res.list.map((accoun_item) => {
          return {
            label: `${accoun_item.advertiser_id}(${accoun_item.advertiser_name})${accoun_item.note ? ' - ' + accoun_item.note : ''}`,
            value: accoun_item.advertiser_id,
          };
        });
      });
    },

    /** 获取项目选择器列表 */
    getProjectSelector() {
      if (this.advertiser_ids?.value?.length) {
        return getProjectSelectorApi({
          advertiser_ids: this.advertiser_ids.value,
        }).then((res) => {
          this.project_ids.options = res.list.map((item) => {
            return {
              label: item.name,
              value: item.type_id,
            };
          });
        });
      }
    },
    /** 跳转到智能创建 */
    toIntelligenceCreate() {
      this.$router.push('/superior/superior-jrtt/intelligence-create-plan');
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-manage {
  // padding: 30px;
  .func-box {
    .el-button {
      margin-left: 10px;
    }
  }
}
/deep/ .el-card {
    margin-bottom: 20px;
}
</style>
